// react documenation used: https://react.dev/learn
// axios documentation used: https://axios-http.com/docs/intro
import React, { useState, useEffect } from "react";
import axios from "axios";
import Nav from "../../layout/navBar/navBar";
import Recent from "../../layout/recentBar/recentBar";
import styles from "./searchPage.module.css";
import classNames from "classnames";
import DetailsPopup from "../../layout/categoryRepoDetails/categoryRepoDetails";

function SearchPage() {
  const [query, setQuery] = useState("");
  const [searchType, setSearchType] = useState("names");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedRepo, setSelectedRepo] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchSearchResults = async () => {
      if (query.trim() !== "") {
        const url = `${apiUrl}/api/requests/search${
          searchType === "code" ? "" : "names"
        }?query=${encodeURIComponent(query)}`;
        try {
          const token = localStorage.getItem("token");
          const response = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          if (searchType === "code" && response.data.codeSearch) {
            const combinedResults = [
              ...(response.data.codeSearch.github || []),
              ...(response.data.codeSearch.gitlab || []),
            ];
            setSearchResults(combinedResults);
          } else if (response.data) {
            setSearchResults(response.data);
          } else {
            setSearchResults([]);
          }
        } catch (error) {
          console.error("Error fetching search results:", error);
          setSearchResults([]);
        }
      } else {
        setSearchResults([]);
      }
    };

    const timeoutId = setTimeout(() => fetchSearchResults(), 3000); // waits 3 secconds before searching, long wait time to make up for github API rates restricting the amount of apis that can be called per min
    return () => clearTimeout(timeoutId);
  }, [query, apiUrl, searchType]);

  const handleRepoSelect = (repo) => {
    setSelectedRepo(repo);
  };

  const handleClosePopup = () => {
    setSelectedRepo(null);
  };

  const getPlatformIcon = (url) => {
    if (url.includes("github.com")) {
      return "/github.png";
    } else if (url.includes("gitlab.com")) {
      return "/gitlab.png";
    } else {
      return null;
    }
  };

  return (
    <div>
      <Nav />
      <div className={styles.home}>
        <header className={styles.header}></header>
        <main className={styles.mainContent}>
          <section className={styles.recentlyAccessed}>
            <Recent />
          </section>
          <section className={styles.sharedRepositories}>
            <h1>Search</h1>
            <div className={styles.searchOptions}>
              <label>
                <input
                  type="radio"
                  value="code"
                  checked={searchType === "code"}
                  onChange={() => setSearchType("code")}
                />
                Search Code
              </label>
              <label>
                <input
                  type="radio"
                  value="name"
                  checked={searchType === "name"}
                  onChange={() => setSearchType("name")}
                />
                Search Repository Names
              </label>
            </div>
            <form
              className={classNames(styles.searchForm, styles.searchPageBar)}
              onSubmit={(e) => e.preventDefault()}
            >
              <div className={styles["searchForm-group"]}>
                <input
                  type="text"
                  id="search"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Search repositories..."
                />
              </div>
            </form>
            {searchResults.length > 0 && (
              <div className={styles.reposContainer}>
                {searchResults.map((repo, index) => (
                  <div
                    key={index}
                    className={styles.repoCard}
                    onClick={() => handleRepoSelect(repo)}
                  >
                    <img
                      src={getPlatformIcon(repo.repository_url)}
                      alt="Platform Icon"
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    {repo.repository_name}
                  </div>
                ))}
              </div>
            )}
          </section>
        </main>
        {selectedRepo && (
          <DetailsPopup repo={selectedRepo} onClose={handleClosePopup} />
        )}
      </div>
    </div>
  );
}

export default SearchPage;
